import { render, staticRenderFns } from "./CategoryAddModal.vue?vue&type=template&id=1b3825bd&"
import script from "./CategoryAddModal.vue?vue&type=script&lang=js&"
export * from "./CategoryAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryAddModal.vue"
export default component.exports